module.exports = __webpack_public_path__ + "img/de_bg_3.0f6b2262.jpeg";